<template>
  <v-container fill-height fluid grid-list-xl>
    <v-row justify="center">
      <v-col cols="12">
        <material-card
          color="green"
          flat
          full-width
          title="Список пользователей"
        >
          <v-data-table
            :headers="headers"
            :items="data"
            :options.sync="options"
            :server-items-length="totalDesserts"
            :loading="loading"
            class="elevation-1"
          >
            <template v-slot:top>
              <v-text-field
                v-model="search"
                label="Поиск по email"
                class="mx-4"
              />
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon
                small
                class="mr-2"
                @click="anketa(item)"
              >
                mdi-book-edit
              </v-icon>
              <v-icon
                small
                class="mr-2"
                @click="editItem(item)"
              >
                mdi-pencil
              </v-icon>
              <v-icon
                small
                @click="banItem(item)"
              >
                mdi-account-off
              </v-icon>
            </template>
          </v-data-table>
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { UsersList } from '@/graphql/users'
import { TransformFields } from '@/mixins/fields'
export default {
  layout: 'dashboard',
  name: 'UserList',
  apollo: {
    UsersList: {
      query: UsersList,
      variables () {
        return {
         search: this.search,
         limit: this.options.itemsPerPage,
         offset: this.options.itemsPerPage * (this.options.page - 1)
        }
       },
      result ({ data, loading }) {
        this.data = []
        let item = []
        if (data.IdentityList !== undefined && data.IdentityList.identity !== undefined) {
          for (const key in data.IdentityList.identity) {
            item = data.IdentityList.identity[key]
            const fields = TransformFields(item.Fields)
            fields.id = item.Id
            this.data.push(fields)
          }
          this.totalDesserts = data.IdentityList.count
        }
        this.loading = false
      },
       update: data => data.IdentityList
    }
  },
  data () {
    return {
      perpage: [5, 10, 15, 20, 100],
      totalDesserts: 0,
      data: [],
      options: {},
      search: '',
      loading: false,
      headers: [
        {
          sortable: false,
          text: 'ID',
          value: 'id'
        },
        {
          sortable: false,
          text: 'E-mail',
          value: 'email'
        },
        {
          sortable: false,
          text: 'Имя',
          value: 'firstname'
        },
        {
          sortable: false,
          text: 'Фамилия',
          value: 'lastname'
        },
        {
          sortable: false,
          text: 'Телефон',
          value: 'phone'
        },
         { text: 'Actions', value: 'actions', sortable: false }
      ]
    }
  },
  watch: {
      options (val) {
         this.loading = true
          this.$apollo.queries.UsersList.refetch()
       }
    },
  methods: {
    anketa (item) {
      console.log(item)
    },
    editItem (item) {
      console.log(item)
    },
    banItem (item) {
        console.log(item)
    }
  }
}
</script>
